import { GlobalService } from '../../shared/global.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { Subscription } from 'rxjs';
import { AssetsService } from 'src/app/shared/services/assets.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { trigger, state, style, animate, transition } from '@angular/animations';
import {Howl, Howler} from 'howler';


declare var $: any;

@Component({
    selector: 'app-reg-ing-sal-cod-publ',
    templateUrl: './registro-ing-sal-cod-publ.component.html',
    styleUrls: ['./registrar-ing-sal-cod.scss'],
    animations: [
        trigger('changeDivSize', [
            state('initial', style({
                backgroundColor: 'green',
                width: '0px',
                height: '0px',
                visibility: 'hidden'
            })),
            state('final', style({
                backgroundColor: 'white',
                width: '80%',
                height: '20%'
            })),
            transition('open => closed', [
                animate('2s')
            ]),
            transition('closed => open', [
                animate('1s')
            ]),
        ]),
    ]
})
export class RegistroIngSalCodPublComponent implements OnInit, OnDestroy {

    public iconDemo: string;
    public codigoFiltro: string;
    public parametros: any;
    public duracionMensajes: any;
    public subscription: Subscription[] = [];
    public mensajeAlerta: string;
    currentState = 'initial';
    private sound = new Howl({
        src: ['assets/alert2.wav']
      });
    constructor(private spiner: NgxSpinnerService
        , private global: GlobalService
        , private router: Router
        , private urlService: UrlService
        , private alertService: AlertService) {
        this.parametros = [];
        this.global.setThemeInit();
        this.iconDemo = AssetsService.URL_ICONO_DEMO_JPG;
        this.mensajeAlerta = "Puede ingresar Sr(a) FABIAN ROMERO ";
    }

    ngOnInit() {
        this.obtenerParametrosIniciales(0);
    }

    obtenerParametrosIniciales(intento) {
        if (intento < 3) {
            if (this.urlService.hostAPI_ACCVIS) {
                this.consultarParametrosPantalla();
            } else {
                setTimeout(() => {
                    this.urlService.refrescar();
                    this.obtenerParametrosIniciales(intento++);
                }, 200);
            }
        } else {
            this.cathException('Error Consultando parametros requeridos por la pantalla');
        }
    }

    /*
     * destruye las subscripciones pendientes por gestionar 
     */
    ngOnDestroy() {
        this.subscription.forEach(subs => {
            subs.unsubscribe();
        });
    }


    /**
     * petición de consulta del código capturado
     */
    consultarCodigo() {

        if (this.codigoFiltro.length > 5) {

            this.spiner.show();

            const queryParams: Array<[string, string]> = new Array<[string, string]>();
            queryParams.push(['codigo', this.codigoFiltro]);
            const serviceProvider = 'ValidarCodigoTalanquera';
            const url = this.urlService.getUrl(new UrlControl(serviceProvider, queryParams, null), this.urlService.hostAPI_ACCVIS);
            const subs = this.global.getPublico(url).subscribe(
                data => {
                    this.mensajeAlerta = data[0].mensaje;
                    this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
                    this.sound.play();
                    this.spiner.hide();
                    this.codigoFiltro = '';
                    setTimeout(() => {
                        this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
                    }, parseInt(this.duracionMensajes) * 1000);
        
                }, err => {
                    this.cathException(err.error.mensaje);
                }
            );
            this.subscription.push(subs);
        }
    }


    /**
     * Obtiene los paràmetros configurados en BD
     * @author fromero
     */
    consultarParametrosPantalla() {
        const serviceProvider = 'ObtenerParametros';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
        const subs = this.global.getPublico(url).subscribe(
            data => {
                this.parametros = data;
                this.setParametros();
            }, err => {
                this.cathException('Error Consultando parametros requeridos por la pantalla');
            }
        );
        this.subscription.push(subs);
    }

    /**
     * Filtra y asigna los parámetros requeridos por la pantalla
     * @author fromero
     */
    setParametros() {

        this.parametros.forEach(element => {
            if (element.nombre == ConstantesService.TIEMPO_DURACION_ALERTA_TALANQUERA) {
                this.duracionMensajes = element.valor;
            }
        });
    }

    /**
     * Catch que genera una alaerta ene le componente cuando hay errores
     * @param err 
     * @author fromero
     */
    cathException(err) {
        this.spiner.hide();
        this.alertService.generateAlertError(err, '');
    }

}
